interface Props {
  target: number | null | undefined;
  lastClose: number | null | undefined;
  count?: number | null;
}

/** Compact "PT $187 +12%" chip — analyst consensus target vs last price. */
export default function AnalystTargetBadge({ target, lastClose, count }: Props) {
  if (target === null || target === undefined || target <= 0) return null;
  const pct =
    lastClose !== null && lastClose !== undefined && lastClose > 0
      ? (target - lastClose) / lastClose * 100
      : null;
  const dirCls =
    pct === null
      ? "bg-slate-500/10 text-slate-300 ring-slate-500/30"
      : pct >= 0
      ? "bg-sky-500/10 text-sky-300 ring-sky-500/30"
      : "bg-rose-500/10 text-rose-300 ring-rose-500/30";
  const pctLabel = pct === null ? "" : ` ${pct >= 0 ? "+" : ""}${pct.toFixed(0)}%`;
  const tooltip =
    count && count > 0
      ? `Avg analyst target $${target.toFixed(2)} (${count} analyst${count === 1 ? "" : "s"})`
      : `Avg analyst target $${target.toFixed(2)}`;
  return (
    <span
      title={tooltip}
      className={`inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-semibold tabular-nums ring-1 ring-inset ${dirCls}`}
    >
      PT ${target.toFixed(0)}{pctLabel}
    </span>
  );
}
